// extracted by mini-css-extract-plugin
export default {"title":"NotFound_title__D8KzW","richtext":"NotFound_richtext__ymQSH"};